var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-header-wrapper",
    [
      _c(
        "a-card",
        { attrs: { bordered: false } },
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                { attrs: { layout: "inline" } },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 48 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { md: 8, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "车辆选择" } },
                            [
                              _c("a-tree-select", {
                                staticClass: "alarm-search",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  replaceFields: _vm.replaceFields,
                                  "show-search": "",
                                  "dropdown-style": {
                                    maxHeight: "400px",
                                    overflow: "auto",
                                  },
                                  placeholder: "模糊搜索，可搜索自编号或车牌号",
                                  "allow-clear": "",
                                  "tree-default-expand-all": "",
                                  "tree-data": _vm.vehicleTreeData,
                                  "tree-checkable": "",
                                  "show-checked-strategy": _vm.SHOW_PARENT,
                                  maxTagCount: 2,
                                  treeNodeFilterProp: "title",
                                },
                                on: { change: _vm.handleVehicleNoChange },
                                model: {
                                  value: _vm.deviceIds,
                                  callback: function ($$v) {
                                    _vm.deviceIds = $$v
                                  },
                                  expression: "deviceIds",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { md: 8, sm: 24 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "报警类型" } },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: { "default-value": "" },
                                  model: {
                                    value: _vm.queryParam.warnType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParam, "warnType", $$v)
                                    },
                                    expression: "queryParam.warnType",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "" } },
                                    [_vm._v(" 全部 ")]
                                  ),
                                  _vm._l(_vm.warnTypeOptions, function (item) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: item.value,
                                        attrs: { value: item.value },
                                      },
                                      [_vm._v(" " + _vm._s(item.label) + " ")]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.advanced ? void 0 : _vm._e(),
                      _c(
                        "a-col",
                        { attrs: { md: (!_vm.advanced && 8) || 24, sm: 24 } },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              style:
                                (_vm.advanced && {
                                  float: "right",
                                  overflow: "hidden",
                                }) ||
                                {},
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleQuery },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "search" } }),
                                  _vm._v("查询"),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  on: { click: _vm.resetQuery },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "redo" } }),
                                  _vm._v("重置"),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-toolbar",
            {
              attrs: { loading: _vm.loading, refresh: "", tid: "1" },
              on: { refreshQuery: _vm.getList },
            },
            [
              _c(
                "div",
                { staticClass: "table-operations" },
                [
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["tenant:jt808:warningRuleArea:add"],
                          expression: "['tenant:jt808:warningRuleArea:add']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.fenceForm.handleAdd()
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "plus" } }),
                      _vm._v("新增电子围栏 "),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["tenant:jt808:warningRuleSpeeding:add"],
                          expression:
                            "['tenant:jt808:warningRuleSpeeding:add']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.OverSpeedForm.handleAdd()
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "plus" } }),
                      _vm._v("新增超速报警 "),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["tenant:jt808:warningRuleForbiddenArea:add"],
                          expression:
                            "['tenant:jt808:warningRuleForbiddenArea:add']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.ForbidenZoneForm.handleAdd()
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "plus" } }),
                      _vm._v("新增禁入区域 "),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["tenant:jt808:warningRuleParkingTimeout:add"],
                          expression:
                            "['tenant:jt808:warningRuleParkingTimeout:add']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.ParkingViolationForm.handleAdd()
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "plus" } }),
                      _vm._v("新增停车超时 "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c("over-speed-form", {
            ref: "OverSpeedForm",
            on: { ok: _vm.getList },
          }),
          _c("fence-form", { ref: "fenceForm", on: { ok: _vm.getList } }),
          _c("forbiden-zone-form", {
            ref: "ForbidenZoneForm",
            on: { ok: _vm.getList },
          }),
          _c("parking-violation-form", {
            ref: "ParkingViolationForm",
            on: { ok: _vm.getList },
          }),
          _c("a-table", {
            attrs: {
              loading: _vm.loading,
              size: _vm.tableSize,
              rowKey: "id",
              tid: "1",
              columns: _vm.columns,
              "data-source": _vm.list,
              pagination: false,
            },
            scopedSlots: _vm._u([
              {
                key: "operation",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleUpdate(record)
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "edit" } }),
                          _vm._v("修改 "),
                        ],
                        1
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleDelete(record)
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "edit" } }),
                          _vm._v("删除 "),
                        ],
                        1
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleBrowse(record)
                            },
                          },
                        },
                        [
                          _c("a-icon", { attrs: { type: "info-circle" } }),
                          _vm._v("查看 "),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _c("a-pagination", {
            staticClass: "ant-table-pagination",
            attrs: {
              "show-size-changer": "",
              "show-quick-jumper": "",
              current: _vm.queryParam.pageNum,
              total: _vm.total,
              "page-size": _vm.queryParam.pageSize,
              showTotal: function (total) {
                return "共 " + total + " 条"
              },
            },
            on: {
              showSizeChange: _vm.onShowSizeChange,
              change: _vm.changeSize,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }